@if ((data?.nodes | async) === null) {
  <shared-ui-modal-loader (closed)="close()"></shared-ui-modal-loader>
} @else {
  <h1
    mat-dialog-title
    sharedUiModalClose
    class="border-base-600 border-b-[1px]"
    [ngClass]="{ 'border-b-[1px]': rows().length !== 0 }"
    (closed)="close()"
    i18n="@@importRoutersModalTitle"
    >Import sites</h1
  >

  <ng-scrollbar appearance="standard" autoHeightDisabled="false">
    <mat-dialog-content>
      @if (rows().length > 0) {
        <div class="mx-[20px] max-h-[calc(95dvh_-_250px)]">
          @for (row of rows(); track row.entity.serviceTag) {
            <div
              class="border-base-600 border-b-[1px] border-t-[1px] border-solid first:border-t-0"
            >
              <shared-store-import-nodes-modal-item
                [item]="row"
                [isDisabled]="
                  row.entity.addedInCurrentAccount ||
                  row.entity.addedInAnotherAccount
                "
                (toggleItem)="toggle(row)"
              />
            </div>
          }
        </div>
      } @else {
        <div class="flex h-[65dvh] flex-col items-center justify-center">
          <svg class="h-[46px] w-[64px]">
            <use xlink:href="#empty"></use>
          </svg>
          <span
            class="text-base-500 mt-[11px] text-center text-[15px] font-bold leading-[18px]"
            i18n="@@importRoutersModalEmpty"
            >No nodes found</span
          >
        </div>
      }
    </mat-dialog-content>
  </ng-scrollbar>

  @if (rows().length !== 0) {
    <shared-ui-info
      id="info-with-handler"
      class="mx-[20px] mt-[24px]"
      i18n-text="@@importNodesModalWarning"
      text="Please use <a>Add site</a> to import sites already added to another account. Clicking the link closes the current window without saving it"
      [type]="InfoTypeEnum.WARNING"
    ></shared-ui-info>
  }

  <mat-dialog-actions class="t:!justify-between !mt-[24px] !px-[20px]">
    @if (selectedNodes().length === 0) {
      <shared-ui-button
        class="t:flex-none flex-1"
        size="stretch"
        [disabled]="rowsCount() === 0"
        mode="outline"
        (clicked)="selectAll()"
        i18n="@@importNodesModalSelectAllButton"
        >Select all</shared-ui-button
      >
    } @else {
      <shared-ui-button
        mode="outline"
        class="t:flex-none flex-1"
        size="stretch"
        [disabled]="rowsCount() === 0"
        (clicked)="deselectAll()"
        i18n="@@importNodesModalDeselectAllButton"
        >Reset</shared-ui-button
      >
    }

    <shared-ui-button
      [disabled]="selectedNodes().length === 0"
      (clicked)="import()"
      size="stretch"
      class="t:flex-none flex-1"
      i18n="@@importRoutersModalImportButton"
      >Confirm</shared-ui-button
    >
  </mat-dialog-actions>
}
